import {
  AsyncState,
  Collections,
  Firebase,
  Profile,
  ProfileView,
  selectProfileView,
  UniversalSnapshot,
} from '@ozark/common';
import {useEffect, useState} from 'react';

export const useErpUsers = (department?: string, skip?: boolean) => {
  const [profiles, setProfiles] = useState<AsyncState<ProfileView[]>>({promised: true});

  useEffect(() => {
    if (skip) {
      setProfiles({promised: false, data: []});
      return;
    }

    const baseQuery = Firebase.firestore.collection(Collections.profiles);
    const query = department ? baseQuery.where('department', '==', department) : baseQuery;

    const unsubscribe = query.onSnapshot(
      snapshot => {
        if (snapshot.empty) {
          setProfiles({promised: false, data: []});
          return;
        }

        const profileList = snapshot.docs
          .map(doc => selectProfileView(doc as UniversalSnapshot<Profile>))
          .filter((profile): profile is ProfileView => profile !== null);

        setProfiles({promised: false, data: profileList});
      },
      err => {
        console.error('Error fetching profiles:', err);
        setProfiles({promised: false, error: err});
      }
    );

    return () => {
      unsubscribe();
    };
  }, [department, skip]);

  return {profiles};
};
